import { useMemo } from "react"

export default function Longitude(props){
    const {params} = props
    const lng = useMemo(() => {
        const {row} = params
        return row?.geometry?.coordinates[0]
    },[params])

    return (
        <>
            <div>{lng}</div>
        </>
    )
}